import { useNavigate, useParams } from "react-router-dom";
import ViewVisitorModal from "../modals/ViewVisitorModal";
import { useVisitorRole } from "../../utils/useVisitorRole";

/** Deep link `/app/visitors/:id` — opens the same modal as the directory View button. */
export default function VisitorDetailsView() {
  const { id } = useParams();
  const navigate = useNavigate();
  const perms = useVisitorRole();
  const backTo = perms.isAdmin ? "/app/visitors/control" : "/app/visitors";

  return (
    <ViewVisitorModal
      visitorId={id}
      isAdmin={perms.isAdmin}
      onClose={() => navigate(backTo, { replace: true })}
    />
  );
}
